// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { useNavigate, useParams } from 'react-router-dom';
import { CreateDocumentConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import LinkText from '../../../../Atoms/LinkText';
import { getReportExecutionState } from './reportExecutionState';

const CreateDocumentReport: FC<ProcedureReportProps> = ({ report, config, disableLinks = false }) => {
  const { entityId, executionStatus } = report ?? {};
  const { documentType, templateName, originDocument, finalInvoice } = config as CreateDocumentConfigDTO;
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const executionState = getReportExecutionState(executionStatus);
  const documentCreated = executionState === 'COMPLETED';
  const documentLabelKey =
    finalInvoice && documentType === 'INVOICE' ? 'document.final_invoice' : `document.${documentType.toLowerCase()}`;

  const onClick = () => {
    if (eventId && documentCreated) {
      navigate(`/events/${eventId}/documents/${entityId}`);
    }
  };

  const documentNode = () => (
    <Text
      span
      weight="bolder"
      onClick={onClick}
      variant={documentCreated ? 'link' : 'text'}
      sx={(theme) => ({
        cursor: documentCreated ? 'pointer' : 'default',
        pointerEvents: disableLinks ? 'none' : undefined,
        color: documentCreated
          ? theme.colorScheme === 'dark'
            ? theme.colors.blue[1]
            : theme.colors.blue[4]
          : 'inherit',
      })}
    >
      {i18n._(documentLabelKey)}
    </Text>
  );

  if (originDocument) {
    const { label } = originDocument;
    return (
      <Text>
        {executionState === 'SKIPPED' ? 'Erstellung von ' : ''}
        {documentNode()}{' '}
        {executionState === 'COMPLETED' && 'wurde aus Dokument'}
        {executionState === 'PLANNED' && 'wird aus Dokument'}
        {executionState === 'SKIPPED' && 'aus Dokument'}
        {executionState === 'NOT_EXECUTED' && 'wurde nicht aus Dokument'}{' '}
        <Text span weight="bolder">
          {label}
        </Text>
        {executionState === 'SKIPPED' ? ' übersprungen.' : ' erstellt.'}
      </Text>
    );
  }

  if (templateName) {
    return (
      <Text>
        {executionState === 'SKIPPED' ? 'Erstellung von ' : ''}
        {documentNode()}{' '}
        {executionState === 'COMPLETED' && 'wurde aus Vorlage'}
        {executionState === 'PLANNED' && 'wird aus Vorlage'}
        {executionState === 'SKIPPED' && 'aus Vorlage'}
        {executionState === 'NOT_EXECUTED' && 'wurde nicht aus Vorlage'}{' '}
        <LinkText
          span
          disabled={disableLinks}
          weight="bolder"
          onClick={() => navigate(`/settings/template/document/${documentType.toLowerCase()}/${templateName}`)}
        >
          {templateName}
        </LinkText>
        {executionState === 'SKIPPED' ? ' übersprungen.' : ' erstellt.'}
      </Text>
    );
  }

  return null;
};

export default CreateDocumentReport;
